<ion-toggle [ngModel]="checked"
            (ngModelChange)="onCheckedChange($event)"
            [disabled]="disabled"
            [color]="color"></ion-toggle>
